import { render, staticRenderFns } from "./AddNewReport.vue?vue&type=template&id=90225228&scoped=true"
import script from "./AddNewReport.vue?vue&type=script&lang=js"
export * from "./AddNewReport.vue?vue&type=script&lang=js"
import style0 from "./AddNewReport.vue?vue&type=style&index=0&id=90225228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90225228",
  null
  
)

export default component.exports